<template>
<div id="app">

  <b-container fluid>
    <b-row>
      <b-col cols="12">
<side-bar v-if="loggedIn" ></side-bar>
    
<router-view></router-view>  
</b-col>
    </b-row>
  </b-container>
</div>
</template>
<script>
import {auth} from 'C:\\Users\\dj\\JsProjects\\aims-dashboard\\src\\firebase.js'
import sidebar from './components/sidebar'

export default {
  data () {
    return {
    loggedIn: false  
    }
  },
  components: {
    'side-bar': sidebar
  },
  mounted() {
   
    auth.onAuthStateChanged(user => {
     console.log(user)
     if(user !== null){
       
      this.loggedIn = true
      console.log(this.loggedIn) 
     }else{
       this.loggedIn = false
       console.log(this.loggedIn) 
     }
    });
  }
}
</script>
<style>
#app{
    height: 100%;
}
html{
    height: 100%;
}

</style>